import React from 'react';
import Button from './Button';

import collaborationImage from "../assets/images/collaboration_img.png";
import brochurePDF from "../assets/images/brochure.pdf";

// const COLLABORATION_IMAGE = 'https://placehold.co/600x400/1e3a5f/ffffff?text=IASG+Mid-Term+Conference+2026';

const bulletPoints = [
  'International Faculty',
  'Key Note Addresses',
  'Laparoscopic Skill Lab',
  'Interesting Panel Discussion',
  'Robotic Surgery',
  'A I in Surgery',
  'Oral & Poster Presentations',
  'Case Based Discussions',
  'Video Presentation',
];

function GlobalCollaborationSection() {
  return (
    <section id="program" className="section collaboration-section">
      <div className="container">
        <div className="collaboration-grid">
          <div className="collaboration-content">
            <h2 className="collaboration-title">G.I. Oncology: From Basics to Clinical Practice</h2>
            <p className="collaboration-text">
              The conference, themed "G.I. Oncology: From Basics to Clinical Practice", aims to serve as a beacon of scientific excellence in the field of Surgical Gastroenterology. It will be useful for Residents of General Surgery / Onco. Surgery / Pediatric Surgery, and Practicing General Surgeons, G.I. Surgeons and Onco. Surgeons. Our meticulously curated two-day scientific programme is designed to comprehensively address recent updates and evolving practices in Surgical Gastroenterology.
            </p>
            <ul className="collaboration-list">
              {bulletPoints.map((item) => (
                <li key={item}>
                  <i className="ri-checkbox-circle-line collaboration-check" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <Button variant="secondary" href="#program" iconRight="ri-arrow-right-line" onClick={() => window.open(brochurePDF, "_blank")}>
              View Programme
            </Button>
          </div>
          <div className="collaboration-media">
            <img src={collaborationImage} alt="IASG Mid-Term Conference 2026" className="collaboration-image" />
            {/* <p className="collaboration-caption">IASG Mid-Term Conference 2026</p> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default GlobalCollaborationSection;
